import {
  recordBookingCreationFailure,
  recordSignInFailure,
  recordSmsVerificationFailure,
} from "@/services/record-expected-outcome";

export function recordExpectedApiOutcome({
  bookingMode,
  code,
  endpoint,
  method,
}) {
  const signInFailureReason = {
    ACCOUNT_PENDING: "account_pending",
    CUSTOMER_ACCOUNT_UNCLAIMED: "account_unclaimed",
    EMAIL_OR_PASSWORD_INVALID: "invalid_credentials",
    USER_NOT_EXISTS: "invalid_credentials",
  }[code];
  if (
    method === "POST" &&
    ["/admin/signin", "/customer/signin", "/therapist/signin"].includes(
      endpoint
    ) &&
    signInFailureReason
  ) {
    recordSignInFailure({
      accountRole: endpoint.split("/")[1],
      failureReason: signInFailureReason,
    });
    return;
  }

  const smsFailureReason = {
    PHONE_NOT_VERIFIED: "not_verified",
    PHONE_VERIFICATION_EXPIRED: "expired",
    SMS_OTP_EXPIRED: "expired",
    SMS_OTP_INVALID: "invalid_code",
    SMS_OTP_RATE_LIMITED: "rate_limited",
    SMS_OTP_RESEND_TOO_SOON: "resend_too_soon",
    SMS_OTP_TOO_MANY_ATTEMPTS: "too_many_attempts",
  }[code];
  if (
    method === "POST" &&
    ["/customer/signup", "/therapist/signup"].includes(endpoint) &&
    smsFailureReason
  ) {
    recordSmsVerificationFailure({
      accountRole: endpoint.split("/")[1],
      failureReason: smsFailureReason,
      operation: "verify",
    });
    return;
  }
  if (
    method === "POST" &&
    /^\/(customer|therapist)\/signup\/sms\/(send|resend|verify)$/.test(
      endpoint
    ) &&
    smsFailureReason
  ) {
    recordSmsVerificationFailure({
      accountRole: endpoint.split("/")[1],
      failureReason: smsFailureReason,
      operation: endpoint.split("/")[4],
    });
    return;
  }

  const bookingFailureReason = {
    BOOKING_TOO_SOON: "booking_too_soon",
    OFFICE_NOT_AVAILABLE: "office_not_available",
    SLOT_ALREADY_BOOKED: "slot_already_booked",
    SLOT_NOT_ALIGNED: "slot_not_aligned",
    SLOT_OFFER_NOT_AVAILABLE: "offer_not_available",
    SLOT_OUTSIDE_OPENING_HOURS: "outside_opening_hours",
    SLOT_OVERLAP: "slot_overlap",
    SLOT_OVERLAPS_ABSENCE: "overlaps_absence",
    SLOT_TOO_SOON: "slot_too_soon",
  }[code];
  if (
    method !== "POST" ||
    !["/booking/checkout", "/booking/customer"].includes(endpoint) ||
    !bookingFailureReason
  )
    return;

  recordBookingCreationFailure({
    bookingMode,
    failureReason: bookingFailureReason,
  });
}
